import HomeHeader from "../Component/HomeComponent/HomeHeader";

import ShowCaseCardRow from "../Component/HomeComponent/ShowCaseCardRow";
// import { projectsData } from "./StaticData/HomeProjectData";
import { useState, useEffect } from "react";
import { PageContainer } from "../Component/HomeComponent/GeneralComponents";
import { useQuery, gql } from "@apollo/client";
import { Spin } from "antd";
import {
  SubPageTitle,
  SectionContainer,
} from "../Component/HomeComponent/GeneralComponents";
import { getUrl } from "aws-amplify/storage";

const GET_PROJECTS = gql`
  query GetProjects {
    home_page_project {
      id
      title
      image
      link
    }
  }
`;

export default function ProjectsPage() {
  const [ismobile, setIsMobile] = useState(0);
  const { data, loading } = useQuery(GET_PROJECTS);
  const [processedProjects, setProcessedProjects] = useState([]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Fetch S3 URLs for project images
  useEffect(() => {
    const getS3Url = async (path) => {
      if (!path || !path.startsWith("websitePicture/")) return path;
      try {
        const { url } = await getUrl({
          key: path,
          options: {
            expiresIn: 3600,
          },
        });
        console.log("S3 URL:", url);
        console.log(url.href);
        return url.href;
      } catch (error) {
        console.error("Fetch S3 URL failed:", error);
        return path;
      }
    };

    const processProjectImages = async () => {
      if (!data?.home_page_project) return;

      try {
        const processed = await Promise.all(
          data.home_page_project
            .filter((project) => project.image)
            .map(async (project) => ({
              ...project,
              image: await getS3Url(project.image),
            }))
        );
        setProcessedProjects(processed);
      } catch (error) {
        console.error("Processing failed:", error);
        setProcessedProjects(data.home_page_project);
      }
    };

    processProjectImages();
  }, [data]);
  return (
    <PageContainer style={{ height: "100vh" }}>
      <Spin spinning={loading} fullscreen />
      <HomeHeader />
      <SectionContainer id="project">
        <SubPageTitle
          ismobile={ismobile}
          style={{
            paddingBottom: 0,
            marginLeft: 0,
            paddingTop: " 8vh",
          }}
        >
          Projects
        </SubPageTitle>

        <ShowCaseCardRow>{processedProjects}</ShowCaseCardRow>
      </SectionContainer>
    </PageContainer>
  );
}
